<template>
  <div class="content" :class="$route.name == 'postShare' ? 'postShare' : ''">
    <div class="content_box">
      <van-sticky
        v-if="
          !$route.meta.leftShow &&
          $padFalg != 'other' &&
          $route.name != 'postShare' &&
          $route.name !== 'rich2'
        "
      >
        <div class="padtab">
          <div class="padtab_logo"></div>
          <div class="padtab_tabbox" v-if="$store.state.gameType != 2">
            <div
              class="padtab_tablist"
              v-for="item in tablist"
              :key="item.id"
              :class="item.class"
              @click="gopage(item)"
            >
              <div class="padtab_tablist_iconbox">
                <div class="padtab_tablist_icon" :class="item.iconclass"></div>
                <div
                  class="message_numicon"
                  v-show="item.name == '消息' && messageNum > 0"
                >
                  {{ messageNum > 99 ? '99+' : messageNum }}
                </div>
              </div>
              <div>{{ item.name }}</div>
            </div>
          </div>
        </div>
      </van-sticky>

      <keep-alive :include="aliveComponent">
        <router-view></router-view>
      </keep-alive>
      <!-- <router-view></router-view> -->
    </div>

    <div
      class="tabbar"
      v-if="
        $route.meta.footShow &&
        $padFalg == 'other' &&
        $store.state.gameType != 5 &&
        $store.state.gameType != 2
      "
    >
      <router-link to="/homePage" class="router">
        <div class="tabbox" @click="tabClick(1)">
          <div class="tab_home" :class="tab_homecur"></div>
          <div class="tab_name" :class="tab_namecur1">首页</div>
        </div>
      </router-link>
      <router-link to="/guidePage" class="router">
        <div class="tabbox" @click="tabClick(2)">
          <div class="tab_strategy" :class="tab_strategycur"></div>
          <div class="tab_name" :class="tab_namecur2">
            {{  this.$store.state.gameType == 2 ? '战备' : this.$store.state.gameType == 3 ?'攻略':this.$store.state.gameType == 4 ? '攻略' : '百科',}}
          </div>
        </div>
      </router-link>
      <div class="router">
        <label for="uploadinput">
          <div class="tab_release" @click="tabClick(3)"></div>
        </label>
      </div>
      <!-- <router-link to="/messagePage" class="router"> -->
      <div class="tabbox" @click="tabClick(4)">
        <div class="tab_message" :class="tab_messagecur"></div>
        <div class="tab_name" :class="tab_namecur4">消息</div>
        <div class="message_numicon" v-show="messageNum > 0">
          {{ messageNum > 99 ? '99+' : messageNum }}
        </div>
      </div>
      <!-- </router-link> -->
      <!-- <router-link to="/userPage" class="router"> -->
      <div class="tabbox" @click="tabClick(5)">
        <div class="tab_my" :class="tab_mycur"></div>
        <div class="tab_name" :class="tab_namecur5">我的</div>
      </div>
      <!-- </router-link> -->
    </div>

    <div class="msgIngWrap" v-show="msgIngFlag">
      <textarea
        name="msgIng"
        id="msgIng"
        ref="msgIngCon"
        @blur="msgIngBlur"
      ></textarea>
      <div class="msgIngBot">
        <van-icon name="arrow-down" @click="closeMsgIngWrap" />
        <van-icon name="photo-o" />
        <van-icon name="smile-o" />
        <span class="sentBtn" :data-id="topicId" @click="topicComment"
          >发送</span
        >
      </div>
    </div>
    <div v-show="$store.state.tipFlag" class="tipbox">
      <successful :content="tipcontent"></successful>
    </div>
    <!-- 断网 -->
    <div
      class="offLine"
      :class="connectionFlag ? 'on' : 'off'"
      v-if="connectionOpenGameFlag"
    >
      <div>
        <van-icon
          name="close"
          v-show="
            this.$store.state.system == 'android' &&
            applets != 'xcx' &&
            !$store.state.isXcx &&
            this.$store.state.isInGame
          "
          @click="closeCommunity"
        />
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <img src="@/assets/img/none.png" alt="" />
        <p>网络连接异常，下拉刷新</p>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import successful from './tip/successful.vue';
import get from '@/api/get';
import _ from 'lodash';
import { add } from 'lodash/fp';
import qs from 'qs';
import { Toast } from 'vant';
import { Button, Row, Col, Icon, Cell, CellGroup, Badge } from 'vant';
import { mapState } from 'vuex';
export default {
  name: 'index',
  components: {
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Badge.name]: Badge,
    successful
  },
  props: {
    msg: String
  },
  data() {
    return {
      tipcontent: '發布成功',
      isLoading: false,
      active: 'home',
      msgIngFlag: '',
      msgIngCon: '',
      topicId: '',
      commentId: '',
      tab_namecur1: '',
      tab_namecur2: '',
      tab_namecur4: '',
      tab_namecur5: '',
      tab_homecur: '',
      tab_strategycur: '',
      tab_messagecur: '',
      tab_mycur: '',
      tablist: [
        { id: 0, name: '首页', class: 'cur', iconclass: 'homeicon' },
        {
          id: 1,
          name:
            this.$store.state.gameType == 2
              ? '战备'
              : this.$store.state.gameType == 3
              ? '攻略'
              : '百科',
          class: '',
          iconclass: 'guideicon'
        },
        { id: 2, name: '消息', class: '', iconclass: 'messageicon' },
        { id: 3, name: '我的', class: '', iconclass: 'usericon' }
      ],
      connectionOpenGameFlag: true
    };
  },
  computed: {
    ...mapState({
      messageNum: 'messageNum',
      connectionFlag: 'connectionFlag',
      loginStatus: 'loginStatus',
      gameType: 'gameType'
    }),
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
    aliveComponent() {
      return [
        'homePage',
        'messagePage',
        'guidePage',
        'topicPage',
        'search',
        'hot',
        'userPage',
        'exchangeCenter',
        'pointList'
      ]; // 对应子组件name
    },
    curhistory() {
      return window.location.href.split('#')[1].split('/')[1];
    }
  },
  created() {
    this.tablist.forEach((item, index) => {
      item.class = '';
    });
    if (location.href.indexOf('homePage') != -1) {
      this.tablist[0].class = 'cur';
    } else if (location.href.indexOf('guidePage') != -1) {
      this.tablist[1].class = 'cur';
    } else if (location.href.indexOf('messagePage') != -1) {
      this.tablist[2].class = 'cur';
    } else if (location.href.indexOf('userPage') != -1) {
      this.tablist[3].class = 'cur';
    }
  },
  mounted() {
    this.tabClick(1);
    this.init();
    this.connectionOpenGame();
  },
  watch: {
    curhistory(n, o) {
      if (n) {
        this.init();
      }
    },
    '$route.path': function () {
      if (location.href.indexOf('guidePage') != -1) {
        //监听路由变化
        this.tabClick(2); //控制底部导航选中状态
        if (!this.$store.state.isMobile) {
          this.tablist.forEach((item, index) => {
            item.class = '';
          });
          this.tablist[1].class = 'cur';
        }
      }
    }
  },
  methods: {
    //删除keep-alive缓存，指定详情页缓存
    clearCache(obj) {
      if (obj.$vnode && obj.$vnode.data.keepAlive) {
        if (
          obj.$vnode.parent &&
          obj.$vnode.parent.componentInstance &&
          obj.$vnode.parent.componentInstance.cache
        ) {
          if (obj.$vnode.componentOptions) {
            var key =
              obj.$vnode.key == null
                ? obj.$vnode.componentOptions.Ctor.cid +
                  (obj.$vnode.componentOptions.tag
                    ? `::${obj.$vnode.componentOptions.tag}`
                    : '')
                : obj.$vnode.key;
            var cache = obj.$vnode.parent.componentInstance.cache;
            var keys = obj.$vnode.parent.componentInstance.keys;
            if (cache[key]) {
              if (keys.length) {
                var index = keys.indexOf(key);
                if (index > -1) {
                  keys.splice(index, 1);
                }
              }
              delete cache[key];
            }
          }
        }
      }
      obj.$destroy();
    },
    init() {
      switch (this.curhistory) {
        case 'homePage':
          this.tabClick(1);
          break;
        case 'guidePage':
          this.tabClick(2);
          break;
        case 'postPage':
          this.tabClick(3);
          break;
        case 'messagePage':
          this.tabClick(4);
          break;
        case 'userPage':
          this.tabClick(5);
          break;
        default:
          break;
      }
    },
    onRefresh() {
      location.reload();
    },
    tabClick(id) {
      // if (id == 5 || id == 4) {
      //   if (this.$store.state.loginStatus == 0) {
      //     this.$store.commit("changeLoginShow", true);
      //     return;
      //   }
      // }
      if (id == 3) {
        if (this.$store.state.loginStatus == 0) {
          this.$parent.$refs.login.getTip(1, null);
          this.$store.commit('changeLoginShow', true);
        } else {
          if (this.$store.state.postingFlag) {
            console.log(this.$store.state.status, '999');
            if (this.$store.state.status != 0) {
              switch (this.$store.state.status) {
                case 1:
                  Toast('因违反社区规范被禁言');
                  break;
                case 2:
                  Toast('因违反社区规范被封禁');
                  break;
                default:
                  break;
              }
              return;
            } else {
              this.$router.push({ name: 'postPage' });
            }
          } else {
            Toast('功能维护中，暂不支持发帖');
          }
        }
      }
      this.tab_namecur1 = '';
      this.tab_namecur2 = '';
      this.tab_namecur4 = '';
      this.tab_namecur5 = '';
      this.tab_homecur = '';
      this.tab_strategycur = '';
      this.tab_messagecur = '';
      this.tab_mycur = '';
      switch (id) {
        case 1:
          this.tab_namecur1 = 'tab_namecur';
          this.tab_homecur = 'tab_homecur';
          break;
        case 2:
          this.tab_namecur2 = 'tab_namecur';
          this.tab_strategycur = 'tab_strategycur';
          break;
        case 4:
          this.$router.push({ name: 'messagePage', query: { source: 'tab' } });
          this.tab_namecur4 = 'tab_namecur';
          this.tab_messagecur = 'tab_messagecur';
          break;
        case 5:
          this.$router.push({ name: 'userPage', query: { source: 'tab' } });
          this.tab_namecur5 = 'tab_namecur';
          this.tab_mycur = 'tab_mycur';
          break;
        default:
          break;
      }
    },
    msgIngBlur() {
      this.msgIngCon = this.$refs.msgIngCon.value;
    },
    closeMsgIngWrap() {
      this.msgIngFlag = false;
      this.$refs.inpIngCon.value = this.msgIngCon;
    },
    topicComment() {
      this.topicId = this.$route.query.id;
      let commentData = {
        commentId: this.commentId,
        content: this.msgIngCon,
        replyMemberId: ''
      };
      get.topicComment(this.topicId, qs.stringify(commentData)).then((res) => {
        console.log(res);
      });
    },
    gopage(item) {
      this.tablist.forEach((item, index) => {
        item.class = '';
      });
      item.class = 'cur';
      switch (item.name) {
        case '首页':
          this.$router.push({ name: 'homePage' });
          break;
        case '百科':
          this.$router.push({ name: 'guidePage' });
          break;
        case '战备':
          this.$router.push({ name: 'guidePage' });
          break;
        case '攻略':
          this.$router.push({ name: 'guidePage' });
          break;
        case '消息':
          // if (this.loginStatus == 0) {
          //   this.$store.commit("changeLoginShow", true);
          // } else {
          //   this.$router.push({
          //     name: "messagePage",
          //     query: { source: "tab" },
          //   });
          // }
          this.$router.push({
            name: 'messagePage',
            query: { source: 'tab' }
          });
          break;
        case '我的':
          // if (this.loginStatus == 0) {
          //   this.$parent.$refs.login.getTip(1, null);
          //   this.$store.commit("changeLoginShow", true);
          // } else {
          //   this.$router.push({ name: "userPage", query: { source: "tab" } });
          // }
          this.$router.push({ name: 'userPage', query: { source: 'tab' } });

          break;
        default:
          break;
      }
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
    connectionOpenGame() {
      // console.log(this.$store.state.gameType);
      // console.log(this.$store.state.connectionOpenGame);
      this.$store.state.connectionOpenGame.forEach((n, i) => {
        if (this.$store.state.gameType == n) {
          this.connectionOpenGameFlag = false;
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
:root {
  --theme--bg--color: #2c89f1; //背景 蓝
  --theme--bglight--color: #dfeaf6; //背景 淡蓝
  --theme--bggrey--color: #f0f0f0; //背景 淡灰
  --theme--color: white; //字体 白
  --theme--colorgrey: #808492; //字体 白
}

@import url('../assets/css/index.css');
@import url('../assets/css/uploadPage.css');
@import url('../assets/css/emjoy.css');
@import url('../assets/css/message.css');
@import url('../assets/css/tip.css');
@import url('../assets/css/userPage.css');
@import url('../assets/css/homePage.css');
@import url('../assets/css/postShare.css');
@import url('../assets/css/guidePage.css');
@import url('../assets/css/ipad.css');
@import url('../assets/css/login.css');
@import url('../assets/css/gl_index.css');
// @import url('../assets/css/dqss_index.css');
@import url('../assets/css/dqss_index_new.css');
@import url('../assets/css/lzg_index.css');
@import url('../assets/css/task.css');
@import url('../assets/css/lhlr_index.css');
@import url('../assets/css/rox_index.css');
</style>
